// src/features/orders/driverSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Driver type
export interface Driver {
  id: string;
  [key: string]: any; // flexible, allow extra fields from API
}

// API response shape for list
interface DriverListResponse {
  drivers: Driver[];
  total: number;
  page: number;
  totalPages: number;
}

// Slice state
interface DriverState {
  data: DriverListResponse | null;
  loading: boolean;
  error: string | null;
}

// Payload for updating a driver
export interface DriverUpdatePayload {
  id: string;
  [key: string]: any;
}

// ✅ Initial state
const initialState: DriverState = {
  data: null,
  loading: false,
  error: null,
};

// ✅ Slice
const driverSlice = createSlice({
  name: "driver",
  initialState,
  reducers: {
    // Set full driver list response
    setDriverList(state, action: PayloadAction<DriverListResponse>) {
      state.data = action.payload;
      state.loading = false;
    },

    addDriver(state, action: PayloadAction<any>) {
      console.log(action?.payload, "p");
      const details = action.payload;
      if (!details) return;

      // Use the complete driver data from the API response
      const newDriver: Driver = {
        ...details, // Use all fields from the API response
        id: details.id, // Ensure we use the actual backend ID
      };

      if (state.data?.drivers) {
        state?.data?.drivers?.unshift(newDriver);
        state.data.total += 1;

        if (state.data.drivers.length > 10) {
          state?.data?.drivers?.pop();
        }
      } else {
        state.data = {
          drivers: [newDriver],
          total: 1,
          page: 1,
          totalPages: 1,
        };
      }
    },

    // Update driver by id
    driverUpdate(state, action: PayloadAction<DriverUpdatePayload>) {
      const { id, ...updates } = action.payload;
      if (!id || !state.data) return;

      const driver = state.data.drivers.find((p) => p.id === id);
      if (driver) {
        Object.assign(driver, updates);
      }
    },

    // Set loading state
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    // Set error state
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

// ✅ Export actions
export const { setDriverList, addDriver, driverUpdate, setLoading, setError } =
  driverSlice.actions;

// ✅ Export reducer
export default driverSlice.reducer;
